import { inlineButtonProps } from "components/Button/constants";
import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import RecordLabel from "components/RecordLabel";
import { ChangedBundleBadge } from "containers/Resources/components/Badges/Badges";
import "containers/Resources/components/CommonActions/InlineActionButtons.scss";
import { getRelativeUrl } from "utils/service";
import { BundleActionToolbar } from "./BundleToolbar";
import { BundleTableData } from "./interfaces";

export const bundleColumns = [
    {
        label: "Name",
        key: "name",
        shown: true,
        sortable: true,
        dto: ({ name, id, icon, is_dirty }: BundleTableData) => {
            const link = id ? getRelativeUrl("bundle", id) : null;

            return (
                <>
                    <RecordLabel
                        key={id}
                        link={link}
                        name={name}
                        iconByType="bundle"
                        image={icon}
                    />
                    <ChangedBundleBadge isDirty={is_dirty} />
                </>
            );
        },
    },
    {
        label: "Imported",
        key: "imported",
        shown: true,
        sortable: false,
        dto: ({ installed_version }: BundleTableData) => {
            const icon = installed_version ? IconCollection.check : IconCollection.close;

            return <Icon icon={icon} />;
        },
    },
    {
        label: "Repository",
        key: "repository_name",
        shown: true,
        sortable: false,
        dto: ({ repository_name, repository_id }: BundleTableData) => {
            const link = repository_id ? getRelativeUrl("bundle_repository", repository_id) : null;

            return <RecordLabel key={repository_id} link={link} name={repository_name} />;
        },
    },
    {
        label: "Author",
        key: "author",
        shown: true,
        sortable: false,
        dto: ({ organization_name }: BundleTableData) =>
            organization_name ? <span>{organization_name}</span> : null,
    },
    {
        label: "Current version",
        key: "installed_version",
        shown: true,
        sortable: false,
        dto: ({ installed_version }: BundleTableData) =>
            installed_version ? <span>{installed_version}</span> : null,
    },
    {
        label: "Version",
        key: "version",
        shown: true,
        sortable: false,
        dto: ({ version }: BundleTableData) => (version ? <span>{version}</span> : null),
    },
    {
        label: "Actions",
        key: "actions",
        shown: true,
        sortable: false,
        dto: (data: BundleTableData) => {
            const bundleData = { resourceName: "bundle", resourceData: data };

            return (
                <BundleActionToolbar
                    selectedItems={[bundleData]}
                    afterButtonAction={() => {}}
                    className="inlineActionButtons"
                    buttonProps={inlineButtonProps}
                    isInlineButton
                    selectedName={data.name}
                />
            );
        },
    },
];
